export const STATE_TYPE = 'State';
export const CUSTOM_STATE_TYPE = 'CustomState';
export const SELECT_TYPE = 'Select';
export const MULTI_SELECT_TYPE = 'MultiSelect';
export const MULTI_ENUM_TYPE = 'MultiEnum';
export const CUSTOM_SELECT_TYPE = 'CustomSelect';
export const NUMBER_TYPE = 'Number';
export const VALIDATED_NUMBER_TYPE = 'ValidatedNumber';
export const INTEGER_TYPE = 'Integer';
export const TEXT_TYPE = 'Text';
export const BIG_TEXT_TYPE = 'BigText';
export const MAPPING_TYPE = 'Mapping';
export const DATE_TIME_TYPE = 'DateTime';
export const DATE_TYPE = 'Date';
export const TIME_TYPE = 'Time';
export const LOCAL_DATE_TIME = 'LocalDateTime';
export const BOOLEAN_TYPE = 'Boolean';
export const GROUP_TYPE = 'Group';
export const LINK_TYPE = 'Link';
export const CHECKBOX_TYPE = 'Checkbox';
export const SOLD_TO_TYPE = 'SoldTo';
export const RETURN_COST_TYPE = 'returnCostWithoutVAT';
export const PASSWORD_TYPE = 'Password';
export const EXTENDABLE_SELECT_TYPE = 'ExtendableSelect';

export const TRANSPORT_COMPANIES_TYPE = 'AutogroupingCarrier';

export const CONSTRUCTOR_TYPE = 'Constructor';

export const ENUM_TYPE = 'Enum';
export const ACTIVE_TYPE = 'active';
export const LABELS_TYPE = 'Labels';
